module.exports = __webpack_public_path__ + "static/3-HOLOPORTATION-7173edc8e81f366d5077235d12e60383.png";